// src/components/Unauthorized.js

import React from 'react';

function Unauthorized() {
  return (
    <div className="container mx-auto p-4 text-center">
      <h1 className="text-3xl font-bold mb-6">Unauthorized Access</h1>
      <p className="text-lg">You do not have permission to view this page.</p>
    </div>
  );
}

export default Unauthorized;
